import BaseRepository from '@/api/repositories/BaseRepository';
import store from '@/store/index';

class RepairShopRepository extends BaseRepository {
	get endpoint() {
		return 'api/repairshops';
	}

	get repairShopId() {
		return store.getters.getUser.person.company.companyable.id;
	}

	damageAssessors(repairshopId, params = {}) {
		return this.get(`${repairshopId}/damageassessors`, params);
	}

	lawyersOffices(repairshopId, params = {}) {
		return this.get(`${repairshopId}/lawyers_offices`, params);
	}

	premiumLawyersOffices(repairshopId, params = {}) {
		return this.get(`${repairshopId}/premium_lawyers_offices`, params);
	}

	disableDamageAssessor(repairshopId, damage_assessor_id, disable) {
		return this.put(`${repairshopId}/damageassessors/${damage_assessor_id}`, { disable });
	}

	disableLawyerOffice(repairshopId, lawyer_office_id, disable) {
		return this.put(`${repairshopId}/lawyers_offices/${lawyer_office_id}`, { disable });
	}
}

export default new RepairShopRepository();
